import {ErrorModel} from '../../../app.model';
import {ACTION_TYPES} from '../../../app.types';
import {SegmentValidationsAction} from './validation.actions';
import {SegmentValidationModel} from './validation.model';
import {createFeatureSelector, createSelector} from '@ngrx/store';

export interface SegmentValidationsState {
  segmentValidations: SegmentValidationModel[];
  segmentValidationIsCreated: boolean;
  error?: ErrorModel;
  validationDeleted: boolean;
  selectedSegmentValidation?: SegmentValidationModel;
  segmentValidationIsUpdated: boolean;
}

const INITIAL_STATE: SegmentValidationsState = {
  segmentValidations: [],
  segmentValidationIsCreated: false,
  error: undefined,
  validationDeleted: false,
  selectedSegmentValidation: undefined,
  segmentValidationIsUpdated: false
};

const STATE_FLAGS = {
  error: null,
  segmentValidationIsCreated: false,
  validationDeleted: false,
  segmentValidationIsUpdated: false
};

export const segmentValidationsFeatureSelector = createFeatureSelector<SegmentValidationsState>('segmentValidationsContainer');
export const selectSegmentValidations = createSelector(segmentValidationsFeatureSelector,
  (state) => state.segmentValidations);


export function segmentValidationsContainer(state: SegmentValidationsState = INITIAL_STATE,
                                            action: SegmentValidationsAction = {type: '?'}) {

  const newState = {...state, ...STATE_FLAGS};
  switch (action.type) {
    case ACTION_TYPES.SEGMENT_VALIDATION_LIST_GET:
      return {...newState, segmentValidations: action.segmentValidations};

    case ACTION_TYPES.SEGMENT_VALIDATION_SET:
      state.segmentValidations.push(action.segmentValidation as SegmentValidationModel);
      return {...newState, segmentValidationIsCreated: true};

    case ACTION_TYPES.SEGMENT_VALIDATION_DELETE:
      const filtered = state.segmentValidations.filter((validation: SegmentValidationModel) => {
        return validation.id !== action.validationId;
      });
      return {...newState, validationDeleted: true, segmentValidations: filtered};

    case ACTION_TYPES.SEGMENT_VALIDATION_SELECTED:
      return {...newState, selectedSegmentValidation: action.segmentValidation};

    case ACTION_TYPES.SEGMENT_VALIDATION_INIT_DIALOG:
      return {...newState, segmentValidationIsUpdated: false, segmentValidationIsCreated: false, error: null};

    case ACTION_TYPES.SEGMENT_VALIDATION_UPDATE:
      const validations = state.segmentValidations.map((validation: SegmentValidationModel) => {
        if (validation.id === action.segmentValidation?.id) {
          validation = action.segmentValidation as SegmentValidationModel;
        }
        return validation;
      });
      return {...newState, segmentValidations: validations, segmentValidationIsUpdated: true};

    case ACTION_TYPES.SEGMENT_VALIDATION_ERROR:
      return {...newState, error: action.error};

    default:
      return state;
  }
}

export const segmentValidationListSelector = (state: any) => state.segmentValidationsContainer.segmentValidations;
export const segmentValidationIsCreatedSelector = (state: any) => state.segmentValidationsContainer.segmentValidationIsCreated;
export const segmentValidationIsUpdatedSelector = (state: any) => state.segmentValidationsContainer.segmentValidationIsUpdated;
export const segmentValidationErrorSelector = (state: any) => state.segmentValidationsContainer.error;
export const segmentValidationDeletedSelector = (state: any) => state.segmentValidationsContainer.validationDeleted;
